import commonJs from './common/app';
import initThematicBlockMobilize from './mobilize/cpThematicBlockMobilize';
import HeaderSearch from './common/headerSearch';

document.addEventListener('DOMContentLoaded', () => {
  commonJs()
  initThematicBlockMobilize();

  new HeaderSearch();
});
